import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum ESalesRoute {
  sales = 'sales',
  summary = 'summary',
  quotations = 'quotations',
  view = 'view',
}

CamRoutes.addRoute({
  key: ESalesRoute.sales,
  url: 'sales',
  children: [
    {
      key: ESalesRoute.summary,
      url: 'summary',
    },
    {
      key: ESalesRoute.quotations,
      url: 'quotations',
    },
    {
      key: ESalesRoute.view,
      url: 'view/:id',
    },
  ],
});

export const salesRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([ESalesRoute.sales, ESalesRoute.summary]),
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./pages/sales.component').then(c => c.SalesPage),
    children: [
      {
        path: CamRoutes.getUrl([ESalesRoute.sales, ESalesRoute.summary]),
        loadComponent: () =>
          import('./pages/sales/dashboard/sales-dashboard.component').then(c => c.SalesDashboardComponent),
      },
      {
        path: CamRoutes.getUrl([ESalesRoute.sales, ESalesRoute.quotations]),
        loadComponent: () => import('./pages/sales/quotations/quotations.component').then(c => c.QuotationsPage),
      },
    ],
  },
  {
    path: CamRoutes.getUrl([ESalesRoute.sales, ESalesRoute.view]),
    loadComponent: () =>
      import('./pages/sales/view/quotation-version-details.component').then(c => c.QuotationVersionDetailsPage),
  },
];
